import { animate } from "motion";
import type { HTMLMotionProps } from "motion/react";
import { RefObject } from "react";

export const fadeAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 },
};

export const slideInOutAnimation = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: "auto" },
  exit: { opacity: 0, height: 0 },
  transition: { duration: 0.25 },
};

export const expandCollapseAnimation = {
  initial: { opacity: 0, scale: 0.95, height: 0, marginTop: 0, marginBottom: 0 },
  animate: { opacity: 1, scale: 1, height: "auto", marginTop: "0.25rem", marginBottom: "0.25rem" },
  exit: { opacity: 0, scale: 0.95, height: 0, marginTop: 0, marginBottom: 0 },
  transition: { duration: 0.3 },
};

export const popInOutAnimation = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
  transition: { duration: 0.2 },
};

type MotionAnimation = Pick<HTMLMotionProps<"div">, "initial" | "animate" | "exit" | "transition">;

export const sidecarDrawerAnimation: MotionAnimation = {
  initial: { x: "100%" },
  animate: { x: 0 },
  exit: { x: "100%" },
  transition: { duration: 0.2, ease: "easeInOut" },
};

export const sidecarBackdropAnimation: MotionAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: "easeInOut" },
};

export async function scrollToListTop(containerRef: RefObject<HTMLUListElement | null>) {
  const container = containerRef.current;
  if (!container) return;

  await animate(container.scrollTop, 0, {
    duration: 0.4,
    ease: "circOut",
    onUpdate: (latest) => (container.scrollTop = latest),
  });
}

export async function animatePulse(elementRef: RefObject<HTMLElement | null>): Promise<void> {
  if (!elementRef?.current) return;

  elementRef.current.style.transition = "none";

  await animate(
    elementRef.current,
    { opacity: [null, 0.3, 1] },
    {
      duration: 0.4,
      repeat: 2,
      ease: "easeInOut",
    },
  );

  elementRef.current.style.transition = "";
  elementRef.current.style.opacity = "";
}
